var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2160_12054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5752 0C5.91895 0 6.2002 0.279844 6.2002 0.625V2.5H13.7002V0.625C13.7002 0.279844 13.9814 0 14.3252 0C14.6689 0 14.9502 0.279844 14.9502 0.625V2.5H16.2002C17.5791 2.5 18.7002 3.61914 18.7002 5V17.5C18.7002 18.8789 17.5791 20 16.2002 20H3.7002C2.31934 20 1.2002 18.8789 1.2002 17.5V5C1.2002 3.61914 2.31934 2.5 3.7002 2.5H4.9502V0.625C4.9502 0.279844 5.23145 0 5.5752 0ZM17.4502 7.5H2.4502V17.5C2.4502 18.1914 3.00996 18.75 3.7002 18.75H16.2002C16.8916 18.75 17.4502 18.1914 17.4502 17.5V7.5ZM16.2002 3.75H3.7002C3.00996 3.75 2.4502 4.30859 2.4502 5V6.25H17.4502V5C17.4502 4.30859 16.8916 3.75 16.2002 3.75Z",
    fill: "#D93A4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2160_12054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 20,
    fill: "white",
    transform: "translate(1.2002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCalendar);
export default __webpack_public_path__ + "static/media/Red_calendar.10199a9de8be62c219f94c0628cca110.svg";
export { ForwardRef as ReactComponent };